import type { SVGAttributes } from 'react'

export interface JellowLogoProps extends SVGAttributes<SVGSVGElement> {}

export default function JellowLogo({ ...props }: JellowLogoProps) {
	return (
		<svg
			width="37"
			height="37"
			viewBox="0 0 37 37"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_2059_9871)">
				<rect width="37" height="37" fill="#0D1F26" />
				<rect width="37" height="37" fill="url(#paint0_radial_2059_9871)" />
				<g opacity="0.16" filter="url(#filter0_f_2059_9871)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M24.0192 6.26343L18.5002 17.6591L24.0192 29.0548L29.8959 23.1781L18.5002 17.6591L29.8959 12.1401L24.0192 6.26343ZM7.10449 12.1402L18.5002 17.6591L7.1045 23.1781L12.9812 29.0548L18.5002 17.6591L12.9812 6.26346L7.10449 12.1402Z"
						fill="white"
					/>
				</g>
				<g opacity="0.5" filter="url(#filter1_f_2059_9871)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M26.0432 7.4321C26.2099 7.4321 26.345 7.297 26.345 7.13036C26.345 6.96371 26.2099 6.82861 26.0432 6.82861C25.8766 6.82861 25.7415 6.96371 25.7415 7.13036C25.7415 7.297 25.8766 7.4321 26.0432 7.4321ZM29.1651 9.44227C29.4947 9.44227 29.7619 9.17508 29.7619 8.84549C29.7619 8.51591 29.4947 8.24872 29.1651 8.24872C28.8355 8.24872 28.5683 8.51591 28.5683 8.84549C28.5683 9.17508 28.8355 9.44227 29.1651 9.44227ZM7.68977 29.358C7.68977 29.5971 7.49593 29.791 7.25681 29.791C7.01769 29.791 6.82384 29.5971 6.82384 29.358C6.82384 29.1189 7.01769 28.925 7.25681 28.925C7.49593 28.925 7.68977 29.1189 7.68977 29.358ZM6.51856 9.74718C6.80144 9.74718 7.03076 9.51786 7.03076 9.23498C7.03076 8.95209 6.80144 8.72277 6.51856 8.72277C6.23567 8.72277 6.00635 8.95209 6.00635 9.23498C6.00635 9.51786 6.23567 9.74718 6.51856 9.74718ZM30.0796 31.7741C30.0796 32.057 29.8503 32.2863 29.5674 32.2863C29.2845 32.2863 29.0552 32.057 29.0552 31.7741C29.0552 31.4912 29.2845 31.2619 29.5674 31.2619C29.8503 31.2619 30.0796 31.4912 30.0796 31.7741ZM11.7194 9.83585C11.937 9.83585 12.1134 9.65945 12.1134 9.44184C12.1134 9.22424 11.937 9.04784 11.7194 9.04784C11.5018 9.04784 11.3254 9.22424 11.3254 9.44184C11.3254 9.65945 11.5018 9.83585 11.7194 9.83585ZM11.3254 30.5488C11.3254 30.7664 11.149 30.9428 10.9314 30.9428C10.7138 30.9428 10.5374 30.7664 10.5374 30.5488C10.5374 30.3312 10.7138 30.1547 10.9314 30.1547C11.149 30.1547 11.3254 30.3312 11.3254 30.5488ZM30.4736 28.3854C30.6912 28.3854 30.8676 28.209 30.8676 27.9914C30.8676 27.7738 30.6912 27.5974 30.4736 27.5974C30.256 27.5974 30.0796 27.7738 30.0796 27.9914C30.0796 28.209 30.256 28.3854 30.4736 28.3854Z"
						fill="white"
					/>
				</g>
				<path
					d="M26.0687 7.14722L29.1666 8.79148L19.3991 23.9624L7.24365 29.3856"
					stroke="#687C82"
					strokeWidth="0.231485"
				/>
				<g filter="url(#filter2_d_2059_9871)">
					<ellipse cx="29.1651" cy="8.84555" rx="0.596773" ry="0.596773" fill="#BCC5C8" />
				</g>
				<g filter="url(#filter3_d_2059_9871)">
					<circle cx="26.043" cy="7.13036" r="0.301742" fill="#A4B1B5" />
				</g>
				<g filter="url(#filter4_d_2059_9871)">
					<circle cx="7.2567" cy="29.358" r="0.432965" fill="#A4B1B5" />
				</g>
				<ellipse
					opacity="0.5"
					cx="6.51856"
					cy="9.23511"
					rx="0.512208"
					ry="0.512208"
					fill="#A4B1B5"
				/>
				<ellipse
					opacity="0.2"
					cx="29.5674"
					cy="31.7742"
					rx="0.512208"
					ry="0.512208"
					fill="#A4B1B5"
				/>
				<circle opacity="0.3" cx="11.7192" cy="9.44186" r="0.394007" fill="#BCC5C8" />
				<circle opacity="0.5" cx="10.9311" cy="30.5488" r="0.394007" fill="#A4B1B5" />
				<circle opacity="0.5" cx="30.4736" cy="27.9914" r="0.394007" fill="#A4B1B5" />
				<g filter="url(#filter5_dd_2059_9871)">
					<g filter="url(#filter6_i_2059_9871)">
						<path
							d="M8.4943 17.3489L11.8911 20.4767C11.9734 20.5524 12.0082 20.6667 11.9823 20.7754L10.8444 25.5401C10.4085 27.3656 12.3475 28.8405 13.9904 27.9332L18.402 25.4967C18.4969 25.4442 18.6124 25.4455 18.7062 25.5L22.8981 27.9349C24.4953 28.8626 26.4448 27.4882 26.1075 25.6721L25.1959 20.7644C25.1768 20.6615 25.2112 20.5559 25.2872 20.4839L28.6178 17.3304C29.9327 16.0854 29.2246 13.8723 27.4312 13.6218L22.8501 12.9819C22.7489 12.9677 22.6612 12.9044 22.616 12.8127L20.4278 8.37559C19.6214 6.7404 17.277 6.77767 16.523 8.43767L14.5395 12.8043C14.4957 12.9007 14.4055 12.968 14.3005 12.9824L9.66384 13.6191C7.85369 13.8677 7.15018 16.1113 8.4943 17.3489Z"
							fill="#FFCF11"
						/>
					</g>
					<g filter="url(#filter7_f_2059_9871)">
						<path
							d="M10.9573 16.525L13.7831 19.1269C13.8653 19.2026 13.9002 19.3169 13.8742 19.4256L12.9261 23.396C12.677 24.4391 13.7849 25.282 14.7238 24.7634L18.386 22.7408C18.4809 22.6884 18.5965 22.6896 18.6902 22.7441L22.1683 24.7644C23.081 25.2946 24.195 24.5092 24.0023 23.4714L23.2488 19.4146C23.2297 19.3117 23.264 19.2061 23.34 19.1341L26.1068 16.5144C26.8582 15.8029 26.4536 14.5383 25.4288 14.3952L21.6266 13.8641C21.5254 13.8499 21.4377 13.7866 21.3925 13.6949L19.5894 10.0387C19.1286 9.10427 17.7889 9.12557 17.3581 10.0741L15.7172 13.6865C15.6734 13.783 15.5832 13.8502 15.4782 13.8646L11.6256 14.3937C10.5913 14.5357 10.1893 15.8178 10.9573 16.525Z"
							fill="url(#paint1_linear_2059_9871)"
						/>
					</g>
				</g>
			</g>
			<defs>
				<filter
					id="filter0_f_2059_9871"
					x="-0.536342"
					y="-1.37741"
					width="38.0732"
					height="38.0729"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="3.82042" result="effect1_foregroundBlur_2059_9871" />
				</filter>
				<filter
					id="filter1_f_2059_9871"
					x="4.7033"
					y="5.52557"
					width="27.4674"
					height="28.0639"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="0.651522" result="effect1_foregroundBlur_2059_9871" />
				</filter>
				<filter
					id="filter2_d_2059_9871"
					x="27.3338"
					y="7.01419"
					width="3.66253"
					height="3.66277"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="0.617293" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2059_9871" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_2059_9871"
						result="shape"
					/>
				</filter>
				<filter
					id="filter3_d_2059_9871"
					x="24.5066"
					y="5.59403"
					width="3.07269"
					height="3.07269"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="0.617293" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2059_9871" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_2059_9871"
						result="shape"
					/>
				</filter>
				<filter
					id="filter4_d_2059_9871"
					x="5.58914"
					y="27.6905"
					width="3.33489"
					height="3.33514"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="0.617293" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2059_9871" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_2059_9871"
						result="shape"
					/>
				</filter>
				<filter
					id="filter5_dd_2059_9871"
					x="1.42756"
					y="0.803293"
					width="34.2352"
					height="33.7967"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="3.18368" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.996078 0 0 0 0 0.843137 0 0 0 0 0.152941 0 0 0 0.5 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2059_9871" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="1.27347" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_2059_9871"
						result="effect2_dropShadow_2059_9871"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_2059_9871"
						result="shape"
					/>
				</filter>
				<filter
					id="filter6_i_2059_9871"
					x="7.79492"
					y="7.17065"
					width="21.5005"
					height="21.062"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="1.23459" />
					<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.992157 0 0 0 0 0.72549 0 0 0 0 0.211765 0 0 0 1 0"
					/>
					<feBlend mode="normal" in2="shape" result="effect1_innerShadow_2059_9871" />
				</filter>
				<filter
					id="filter7_f_2059_9871"
					x="8.70574"
					y="7.49822"
					width="19.6403"
					height="19.2882"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="0.925939" result="effect1_foregroundBlur_2059_9871" />
				</filter>
				<radialGradient
					id="paint0_radial_2059_9871"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(18.5379 17.8034) rotate(90) scale(17.8034 19.0753)"
				>
					<stop stopColor="#002050" />
					<stop offset="0.795" stopColor="#071E3A" stopOpacity="0.51" />
					<stop offset="1" stopColor="#0E1C24" stopOpacity="0" />
				</radialGradient>
				<linearGradient
					id="paint1_linear_2059_9871"
					x1="18.5"
					y1="7.70044"
					x2="18.5"
					y2="26.1149"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFFCE6" />
					<stop offset="0.541892" stopColor="#FFF393" stopOpacity="0.458108" />
					<stop offset="1" stopColor="#FFEE69" stopOpacity="0" />
				</linearGradient>
				<clipPath id="clip0_2059_9871">
					<rect width="37" height="37" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
